module.exports = __webpack_public_path__ + "static/media/sardanes.03b5a72e.jpg";